import React from 'react';

import PropTypes from 'prop-types';

import Actions from './components/Actions';
import {
  getMessage,
  getStatus,
  getLocalFormattedTime,
  getAssignee
} from '../iotOrderFulfillmentDashboard/utils';
import getUpdatedLocaleValues from './util';

const Row = ({ order, fetchOrders, headers }) => {
  const {
    orderId,
    iotCompanyName,
    iotProductSelected,
    iotActivationOrRenwal,
    iotNewOrExisting,
    createdAt
  } = order;
  const { statusToolTip, statusId } = getStatus(order);
  const { orderAssignedTo } = order;

  return (
    <tr>
      <td data-header-label={headers[0]}>{orderId}</td>
      <td data-header-label={headers[1]}>{iotCompanyName}</td>
      <td data-header-label={headers[2]}>
        {getUpdatedLocaleValues(iotProductSelected)}
      </td>
      <td data-header-label={headers[3]}>
        {getUpdatedLocaleValues(iotActivationOrRenwal || 'Activation')}
      </td>
      <td data-header-label={headers[4]}>
        {getUpdatedLocaleValues(iotNewOrExisting)}
      </td>
      <td data-header-label={headers[5]}>{getLocalFormattedTime(createdAt)}</td>
      <td data-header-label={headers[6]}>{statusToolTip}</td>
      <td data-header-label={headers[7]}>{getAssignee(orderAssignedTo)}</td>
      <td data-header-label={headers[8]}>{getMessage(order, fetchOrders)}</td>
      <td data-header-label={headers[9]}>
        <div className="responsive-table__actions">
          <Actions status={statusId} order={order} fetchOrders={fetchOrders} />
        </div>
      </td>
    </tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  headers: PropTypes.number.isRequired
};

export default Row;
